const {
  API_URL,
  CDN_HOST,
  COMMIT_SHA,
  CSP_ALLOW_UNSAFE_SCRIPTS,
  CSP_NONCE_PLACEHOLDER,
  CSP_PROJECT_NAME,
  CSP_REPORT_BASE_URL,
  CSP_REPORT_SAMPLING_INTERVAL,
  DOCKER_IMAGE_TAG,
  ENABLE_API_PROXY,
  NODE_ENV,
  PROXY_URL,
  SENTRY_DSN,
  SERVE_NEXT_STATIC_ASSETS,
  ZAPIER_ENVIRONMENT,
} = process.env;

const routes = require('../../routes');

// Conditionally activating error tracking based on the presence of SENTRY_DSN
// allows the Bakery project generator to automatically create a Sentry project
// and hook it up to this frontend project (by injecting the DSN value as an
// environment variable).
const errorTracking = SENTRY_DSN
  ? {
      errorTracking: {
        sentryDsn: SENTRY_DSN,
        // ZAPIER_ENVIRONMENT is set by ArgoCD during deploys
        environment: ZAPIER_ENVIRONMENT || '<unknown>',
      },
    }
  : {};

const zapier = {
  API_URL,
  CDN_HOST,
  CSP_ALLOW_UNSAFE_SCRIPTS,
  CSP_NONCE_PLACEHOLDER,
  CSP_PROJECT_NAME,
  CSP_REPORT_BASE_URL,
  CSP_REPORT_SAMPLING_INTERVAL,
  ENABLE_API_PROXY,
  PROXY_URL,
  SERVE_NEXT_STATIC_ASSETS,
};

console.info(`Using config`, JSON.stringify(zapier, null, ' . '));

const config = {
  apiUrl: API_URL,
  commitHash: COMMIT_SHA || DOCKER_IMAGE_TAG || '<unknown>',
  ...errorTracking,
  isProduction: NODE_ENV === 'production',
  next: {
    dir: './src',
  },
  routes,
  serviceName: 'editor',
  zapier,
  // No universal header/footer in the editor
  universalLayout: false,
};

module.exports = config;
